import { PlusCircle } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const EmptyState = () => {
  const { t } = useTranslation(['reservations'])
  const navigate = useNavigate()

  return (
    <div className="reservations-amenities-empty-state">
      <div className="empty-state-icon">
        <img src="/images/3d-house.svg" alt={t('reservations:emptyState.imageAlt')} />
      </div>
      <div className="empty-state-content">
        <h2 className="empty-state-title">{t('reservations:emptyState.title')}</h2>
        <p className="empty-state-subtitle">{t('reservations:emptyState.subtitle')}</p>
        <button
          className="button button-primary empty-state-button"
          onClick={() => navigate('/dashboard/building-dashboard/reservations/amenities/create')}
        >
          <PlusCircle weight="regular" />
          {t('reservations:emptyState.createNewAmenity')}
        </button>
      </div>
    </div>
  )
}

export default EmptyState
